import { defineMessages } from 'react-intl';

export const scope = 'app.containers.MagicLoginPage';

export default defineMessages({
  signingIn: {
    id: `${scope}.signingIn`,
    defaultMessage: 'Signing you in...'
  },
  invalidLink: {
    id: `${scope}.invalidLink`,
    defaultMessage: 'This login link is invalid, has expired, or has already been used.'
  },
  requestNewLink: {
    id: `${scope}.requestNewLink`,
    defaultMessage:
      'Ask the TripAdmit team for a new link, or sign in with your email and password.'
  },
  goToSignIn: {
    id: `${scope}.goToSignIn`,
    defaultMessage: 'Go to sign in'
  }
});
